<svg
  width="25"
  height="26"
  viewBox="0 0 25 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_86_709)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.44037 13C4.44037 13.9422 5.30511 14.6563 7.0346 16.0844L8.38966 17.2033C9.80688 18.3735 10.5155 18.9587 11.0893 18.6883C11.6631 18.418 11.6631 17.499 11.6631 15.6611V13.9238L15.6347 17.2033C17.0519 18.3735 17.7605 18.9587 18.3343 18.6883C18.9081 18.418 18.9081 17.499 18.9081 15.6611V10.3389C18.9081 8.50097 18.9081 7.58201 18.3343 7.31167C17.7605 7.04134 17.0519 7.62646 15.6347 8.7967L11.6631 12.0762V10.3389C11.6631 8.50097 11.6631 7.582 11.0893 7.31167C10.5155 7.04134 9.80688 7.62646 8.38966 8.7967L7.0346 9.91562C5.30511 11.3437 4.44037 12.0578 4.44037 13Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_86_709">
      <rect width="25" height="25" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
